import { Delete, EmailOutlined, PhoneOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ReactComponent as ExportIconSvg } from 'assets/svg/ExportSharableLink.svg';
import CustomBadge from 'components/CustomBadge';
import { PropertyLead } from 'types/PropertyLead';
import { formatDate } from 'util/formatDate';
import { ReactComponent as Budget } from 'assets/svg/budget.svg';
import { ReactComponent as ConstructedArea } from 'assets/svg/constructed-area.svg';

const mockPropertyRequests: PropertyLead[] = [
    {
        id: '1',
        userId: 'user1',
        title: 'Luxury Villa in Dubai Marina',
        description: 'Looking for a modern luxury villa with high-end finishes and amenities',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Dubai Marina'],
        definedArea: 'Dubai Marina',
        propertyType: 'Villa',
        minConstructionArea: 300,
        maxConstructionArea: 500,
        minPlotArea: 400,
        maxPlotArea: 800,
        minBedrooms: 4,
        maxBedrooms: 6,
        minBathrooms: 4,
        maxBathrooms: 6,
        minBudget: 5000000,
        maxBudget: 8000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking',
        furnishing: 'Unfurnished',
        otherSpecificRequirements: 'Sea view, private garden',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '1',
                propertyLeadId: '1',
                name: 'John Doe',
                email: 'john.doe@example.com',
                phone: '+971 50 123 4567',
                website: 'https://example.com',
                facebook: 'https://facebook.com/johndoe',
                instagram: 'https://instagram.com/johndoe',
                linkedin: 'https://linkedin.com/in/johndoe',
                twitter: 'https://twitter.com/johndoe',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '1',
                propertyLeadId: '1',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '1',
                propertyLeadId: '1',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '1',
                propertyLeadId: '1',
                neighborhood: 'Dubai Marina',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'High-end investor',
    },
    {
        id: '2',
        userId: 'user2',
        title: 'Modern Apartment in Downtown',
        description: 'Seeking a contemporary apartment with city views',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Downtown Dubai'],
        definedArea: 'Downtown Dubai',
        propertyType: 'Apartment',
        minConstructionArea: 100,
        maxConstructionArea: 200,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 2,
        maxBedrooms: 3,
        minBathrooms: 2,
        maxBathrooms: 3,
        minBudget: 2000000,
        maxBudget: 3000000,
        urgency: 'Medium',
        commission: 2,
        amenities: 'Gym,Parking',
        furnishing: 'Semi-furnished',
        otherSpecificRequirements: 'City view, balcony',
        isArchived: false,
        status: 'Pending',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '2',
                propertyLeadId: '2',
                name: 'Jane Smith',
                email: 'jane.smith@example.com',
                phone: '+971 50 987 6543',
                website: 'https://example.com',
                facebook: 'https://facebook.com/janesmith',
                instagram: 'https://instagram.com/janesmith',
                linkedin: 'https://linkedin.com/in/janesmith',
                twitter: 'https://twitter.com/janesmith',
                contactTime: '10:00 AM - 7:00 PM',
            },
        ],
        cities: [
            {
                id: '2',
                propertyLeadId: '2',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '2',
                propertyLeadId: '2',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '2',
                propertyLeadId: '2',
                neighborhood: 'Downtown Dubai',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Young professional',
    },
    {
        id: '3',
        userId: 'user3',
        title: 'Beachfront Penthouse',
        description: 'Looking for a luxury penthouse with direct beach access',
        propertyCountry: 'UAE',
        propertyCity: ['Dubai'],
        propertyState: ['Dubai'],
        propertyNeighborhood: ['Palm Jumeirah'],
        definedArea: 'Palm Jumeirah',
        propertyType: 'Penthouse',
        minConstructionArea: 400,
        maxConstructionArea: 600,
        minPlotArea: 0,
        maxPlotArea: 0,
        minBedrooms: 3,
        maxBedrooms: 4,
        minBathrooms: 3,
        maxBathrooms: 4,
        minBudget: 8000000,
        maxBudget: 12000000,
        urgency: 'High',
        commission: 2,
        amenities: 'Pool,Gym,Parking,Beach Access',
        furnishing: 'Fully furnished',
        otherSpecificRequirements: 'Private beach access, panoramic views',
        isArchived: false,
        status: 'Active',
        createdAt: new Date().toISOString(),
        contactInfo: [
            {
                id: '3',
                propertyLeadId: '3',
                name: 'Mike Johnson',
                email: 'mike.johnson@example.com',
                phone: '+971 50 456 7890',
                website: 'https://example.com',
                facebook: 'https://facebook.com/mikejohnson',
                instagram: 'https://instagram.com/mikejohnson',
                linkedin: 'https://linkedin.com/in/mikejohnson',
                twitter: 'https://twitter.com/mikejohnson',
                contactTime: '9:00 AM - 6:00 PM',
            },
        ],
        cities: [
            {
                id: '3',
                propertyLeadId: '3',
                city: 'Dubai',
            },
        ],
        states: [
            {
                id: '3',
                propertyLeadId: '3',
                state: 'Dubai',
            },
        ],
        neighborhoods: [
            {
                id: '3',
                propertyLeadId: '3',
                neighborhood: 'Palm Jumeirah',
            },
        ],
        savedCount: 0,
        archivedAt: '',
        buyerProfile: 'Luxury investor',
    },
];

export default function MockedSavedRequests() {
    return (
        <div className="pb-10 pt-6">
            <div className="pt-4 bg-white min-h-screen border border-my-gray/70 rounded-lg px-6">
                <div className="flex flex-col gap-6 w-full font-poppins pt-6 rounded-lg">
                    <div className="flex justify-between items-center">
                        <div className="flex gap-2">
                            <h6 className="font-semibold text-my-black/80 text-base">Saved Requests</h6>
                            <span className="h-fit rounded-sm text-white px-2 py-0.5 bg-my-green">{mockPropertyRequests.length}</span>
                        </div>
                        <button className="flex gap-3 sm:w-40 md:w-64 lg:w-auto items-center justify-center border-2 border-blue-500 rounded h-min py-2 px-5">
                            <ExportIconSvg />
                            <span>Export</span>
                        </button>
                    </div>
                    <div className="w-full border border-my-gray/70 mb-6 rounded-t-2xl relative">
                        <div className="grid uppercase default-xl:grid-cols-7 default-sm:grid-cols-5 grid-cols-3 gap-10 items-center text-my-black/60 border border-my-gray/10 border-opacity-40 py-[15px] px-6 bg-my-gray/15 rounded-t-2xl font-medium default-sm:text-base text-[12px]">
                            <span className="default-xl:block hidden">Request Date</span>
                            <span className="col-span-2 default-xl:col-span-1">Title</span>
                            <span className="default-sm:block hidden">Location</span>
                            <span className="col-span-2 default-xl:block hidden">Contact Information</span>
                            <span className="default-sm:block hidden">Status</span>
                            <span>Actions</span>
                        </div>
                        <div className="flex flex-col text-opacity-80">
                            {mockPropertyRequests.map((listing: PropertyLead, index: number) => (
                                <div key={listing.id} className={`p-4 rounded-lg ${index % 2 === 0 ? 'bg-white/60' : 'bg-my-gray/15'}`}>
                                    <div className="grid default-xl:grid-cols-7 default-sm:grid-cols-5 grid-cols-3 text-my-black/80 px-4 font-medium default-sm:text-base text-[12px] gap-10 items-center">
                                        <span className="default-xl:block hidden">{formatDate(listing.createdAt)}</span>
                                        <span className="col-span-2 default-xl:col-span-1">{listing.title}</span>
                                        <span className="default-sm:block hidden">
                                            {listing.definedArea ? listing.definedArea : listing.cities.map((city) => city.city).join(', ')}
                                        </span>
                                        <div className="flex-col gap-4 col-span-2 default-xl:flex hidden">
                                            <div className="flex gap-4">
                                                <EmailOutlined className="text-my-black/50" />
                                                <span>{listing.contactInfo[0].email}</span>
                                            </div>
                                            <div className="flex gap-4">
                                                <PhoneOutlined className="text-my-black/50" />
                                                <span>{listing.contactInfo[0].phone}</span>
                                            </div>
                                        </div>
                                        <CustomBadge status={listing.status} isOpen={false} onToggle={() => {}} />
                                        <div className="items-center justify-between default-sm:flex hidden">
                                            <Button variant="outlined">Details</Button>
                                            <div className="cursor-pointer default-xl:block hidden">
                                                <Delete color="error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
